<script setup lang="ts">
import { computed } from 'vue';

// Custom error messages (replaces vuelidate-error-extractor config)
const messages: Record<string, string> = {
  required: 'This field is required.',
  email: 'This is not a valid email.',
  url: 'Not a valid URL',
  customUrl: 'Not a valid URL',
  minLength: 'This field is too short.',
  maxLength: 'This field is too long.',
};

interface Props {
  // Works with both Vuelidate 0.x and @vuelidate/core
  validator?: {
    $error?: boolean;
    $errors?: Array<{ $message?: string; $validator?: string }>;
    $params?: Record<string, unknown>;
    [key: string]: unknown;
  };
}

const props = defineProps<Props>();

const firstError = computed(() => {
  if (!props.validator?.$error) {
    return null;
  }

  // @vuelidate/core style - has $errors array with $message
  if (props.validator.$errors?.length) {
    const err = props.validator.$errors[0];
    return err.$message || messages[err.$validator || ''] || err.$validator || null;
  }

  // Vuelidate 0.x style - check $params for failed validators
  if (props.validator.$params) {
    for (const validatorName of Object.keys(props.validator.$params)) {
      // In Vuelidate 0.x, failed validators have their key set to false
      if (props.validator[validatorName] === false) {
        return messages[validatorName] || `Invalid: ${validatorName}`;
      }
    }
  }

  return 'This field is invalid.';
});
</script>

<template>
  <div>
    <slot />
    <p v-if="firstError" class="text-red-500 text-sm !mt-1">
      {{ firstError }}
    </p>
  </div>
</template>
